import React, { useState } from 'react';
import { ChevronDown } from 'lucide-react';
import { motion, AnimatePresence } from 'framer-motion';
import { homeFaqs } from '../data/homeFaqs';

const faqs = homeFaqs;

const FAQ = () => {
  const [openIndex, setOpenIndex] = useState(0);


  return (
    <section className="py-10 md:py-16 bg-white" data-testid="faq-section">
      <div className="container mx-auto px-4">
        <div className="max-w-3xl mx-auto">
          <div className="text-center mb-10">
            <div className="inline-flex items-center px-3 py-1 rounded-full bg-[#4DD4AC]/15 text-[#0B7A5A] text-xs font-semibold mb-3">
              FAQ
            </div>
            <h2 className="text-3xl sm:text-4xl font-bold text-[#1A2B3C] mb-3">
              Frequently Asked Questions
            </h2>
            <p className="text-[#4A5B6C]">
              Quick answers to questions parents and students ask us most.
            </p>
          </div>

          <div className="space-y-3">
            {faqs.map((f, idx) => {
              const isOpen = openIndex === idx;
              return (
                <div
                  key={idx}
                  data-testid={`faq-item-${idx}`}
                  className={`border rounded-2xl overflow-hidden transition-all ${
                    isOpen ? 'border-[#4DD4AC] shadow-md' : 'border-gray-200'
                  }`}
                >
                  <button
                    onClick={() => setOpenIndex(isOpen ? -1 : idx)}
                    className="w-full flex items-center justify-between p-5 text-left hover:bg-[#F8FAFC] transition-colors"
                    data-testid={`faq-toggle-${idx}`}
                    aria-expanded={isOpen}
                  >
                    <span className="font-semibold text-[#1A2B3C] pr-4">{f.q}</span>
                    <ChevronDown
                      size={20}
                      className={`flex-shrink-0 text-[#2B5B8A] transition-transform duration-300 ${
                        isOpen ? 'rotate-180' : ''
                      }`}
                    />
                  </button>
                  <AnimatePresence initial={false}>
                    {isOpen && (
                      <motion.div
                        initial={{ height: 0, opacity: 0 }}
                        animate={{ height: 'auto', opacity: 1 }}
                        exit={{ height: 0, opacity: 0 }}
                        transition={{ duration: 0.25 }}
                      >
                        <div className="px-5 pb-5 text-[#4A5B6C] leading-relaxed text-sm">
                          {f.a}
                        </div>
                      </motion.div>
                    )}
                  </AnimatePresence>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
};

export default FAQ;
